angular.module('admin')
  .controller('AdminsCtrl', ['AccountService', '$state', 'FEATURES', function(AccountService, $state, FEATURES){

    if(!AccountService.hasFeature(FEATURES.ADMIN))
      $state.go('login');

  }]);
